import {isPlainObject} from '../../../../utils/isPlainObject';
import type {ApiError} from '../errors';

const isDev = () => {
  return typeof window !== 'undefined';

};

const isEnabled = (): boolean => {
  if (!isDev()) {
    return false;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.localStorage.getItem('api:debug') === '1';
  } catch {
    return false;
  }
};

const getDetailsSummary = (details: unknown) => {
  if (!isPlainObject(details)) {
    return {hasDetails: details !== undefined};
  }

  const obj = details;
  const responseText = typeof obj.responseText === 'string' ? obj.responseText : undefined;

  return {
    hasDetails: true,
    hasCause: 'cause' in obj,
    hasRaw: 'raw' in obj,
    hasRpcData: 'rpcData' in obj,
    responseTextLength: responseText ? responseText.length : 0,
    meta: isPlainObject(obj.meta) ? obj.meta : undefined,
  };
};

export const debugLogApiError = (error: ApiError, context: {methodName: string}) => {
  if (!isEnabled()) {
    return;
  }

  const payload = {
    methodName: context.methodName,
    kind: error.kind,
    status: error.status,
    code: error.code,
    message: error.message,
    details: getDetailsSummary(error.details),
  };

  console.groupCollapsed(
    `[api] ${payload.kind} ${payload.methodName} (${String(payload.status ?? '-')}/${String(payload.code ?? '-') })`
  );
  console.debug(payload);
  console.groupEnd();
};
